import script from "./MedicationCalendarTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./MedicationCalendarTable.vue?vue&type=script&lang=ts&setup=true"

import "./MedicationCalendarTable.vue?vue&type=style&index=0&id=0dba01ce&lang=scss"

const __exports__ = script;

export default __exports__